import { GlobalId } from "@/Types/tableDataTypes";
import { usePage } from "@inertiajs/vue3";
import { useProjectStore } from "../../../Modules/ProjectManagement/Resources/js/store/index";
import { ProjectPermissionsType } from "../../../Modules/ProjectManagement/Resources/js/types/ProjectStoreState";

const pageProps: any = usePage();

export function useProjectPermissions() {
  const canAccess = (permissionName: string, id: string | number) => {
    const pS = useProjectStore();
    const pPerms = pageProps?.props?.app?.projectPermissions || pS.projectPermissions;
    const ProjectPermissions: ProjectPermissionsType = pPerms;
    if (!permissionName || !ProjectPermissions) return false;
    if (permissionName === '*') {
      return true;
    }
    if (ProjectPermissions === '*') {
      return true;
    }
    if (ProjectPermissions[id]) {
      if (ProjectPermissions[id] === "*") {
        return true
      }
      return ProjectPermissions[id].indexOf(permissionName) !== -1;
    }
    return false;
  };
  return {
    canAccess
  };
}

export function usePermissions(permissions = null) {
  const checkPermission = (permissionName: string): boolean => {
    const permissionsData: any = pageProps?.props?.app?.permissions || permissions;
    if (!permissionName || !permissionsData) return false;
    if (permissionsData === "*") return true;
    return permissionsData.includes(permissionName);
  };
  return { checkPermission };
}